<template>
  <div class="OfficialAccounts">
    <!-- 标题 -->
    <div class="title">
      <img
        src="../../assets/images/newIcon/vipanalysis_wxgzh_icon@2x.png"
        alt=""
      />
      <span>微信公众号分析</span>
    </div>
    <!-- 顶部卡片区域 -->
    <el-card class="top-card" shadow="never">
      <div class="main">
        <!-- 小窗区域 -->
        <el-card class="h5">
          <!-- 标题 -->
          <div class="title">GYMOO+</div>
          <!-- 图片 -->
          <div class="banner">
            <img src="../../assets/images/newIcon/wx_kx_bc@2x.png" alt="" />
            <p>迎开学、送福利！手慢无！</p>
          </div>
          <div class="body">
            <div class="cell first">
              <div class="text">
                最新！电子驾驶证申领图文攻略 | 驾驶证照片更换
              </div>
              <div class="cell-img">
                <img
                  src="../../assets/images/newIcon/wx_jiazhao_bc@2x.png"
                  alt=""
                />
              </div>
            </div>

            <div class="cell">
              <div class="text">
                【长花寸说】腾讯视频优化超前颠簸服务；小米汽车正式注册落户北京
              </div>
              <div class="cell-img">
                <img src="../../assets/images/newIcon/wx_xm_bc@2x.png" alt="" />
              </div>
            </div>

            <div class="cell">
              <div class="text">
                【长花寸说】三星起诉华为再次败诉；苹果正研发面容ID有望实现戴口罩识别
              </div>
              <div class="cell-img">
                <img
                  src="../../assets/images/newIcon/wx_apple_bc@2x.png"
                  alt=""
                />
              </div>
            </div>

            <div class="cell">
              <div class="text">新姿势：打喷嚏真的代表有人在想你吗？</div>
              <div class="cell-img">
                <img
                  src="../../assets/images/newIcon/wx_dpt_bc@2x.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </el-card>
        <!-- 右侧梯形图区域 -->
        <div class="data">
          <div class="top clearfix">
            <!-- 左侧文字 -->
            <div class="fl">
              <span class="fz16">最新图文</span>
              <span class="fz12" style="margin-left: 15px">图文数量</span>
            </div>
            <!-- 右侧区域 -->
            <div class="fr">
              <p>
                <img
                  src="../../assets/images/newIcon/ss_shaixuan_icon.png"
                  alt=""
                />
                <el-select
                  style="width: 100px"
                  v-model="options1.value"
                  placeholder="请选择"
                  class="my-select"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </p>
            </div>
          </div>
          <div class="bottom">
            <div class="b1">
              <div class="b1-l">
                <div class="text">
                  <p class="fz26 fff">3.08%</p>
                  <p class="fz12 fff">图文打开率</p>
                </div>
              </div>
              <div class="text2">
                <div class="div1" style="margin-left: 50px">
                  <p class="fz12">推送</p>
                  <p class="fz22 fw">19,359,329<span class="fz12">人</span></p>
      
                </div>
                <div class="div1" style="margin-left: 50px">
                  <p class="fz12">推送</p>
                  <p class="fz22 fw">19,359,329<span class="fz12">人次</span></p>
                  <p class="fz22 fw">19,359,329<span class="fz12">人</span></p>
                </div>
                <div class="div1" style="margin-left: 50px">
                  <p class="fz12">分享</p>
                  <p class="fz22 fw">19,359,329<span class="fz12">人</span></p>
                  <p class="fz22 fw">19,359,329<span class="fz12">人次</span></p>
                </div>
              </div>
              <div class="b1-r"></div>
            </div>
            <div class="b2">
              <div class="b2-l">
                <div class="text">
                  <p class="fz26 fff">3.08%</p>
                  <p class="fz12 fff">图文点击率</p>
                </div>
              </div>
              <div class="text2">
                <div class="div1" style="margin-left: 50px">
                  <p class="fz12" style="margin-top:10px;">图文引流PV</p>
                  <p class="fz22 fw" style="margin-top:10px;">19,359,329<span class="fz12">人</span></p>
      
                </div>
                <div class="div1" style="margin-left: 50px">
                  <p class="fz12" style="margin-top:10px;">图文引流PV</p>
                  <p class="fz22 fw" style="margin-top:10px;">19,359,329<span class="fz12">人</span></p>
                </div>

              </div>
              <div class="b2-r"></div>
            </div>
            <div class="b3">
              <div class="b3-l">
                <div class="text">
                  <p class="fz26 fff">3.08%</p>
                  <p class="fz12 fff">图文下单率</p>
                </div>
              </div>
              <div class="text2">
                <div class="div1" style="margin-left: 50px">
                  <p class="fz12" style="margin-top:10px;">下单人数</p>
                  <p class="fz22 fw" style="margin-top:10px;">19,359,329<span class="fz12">人</span></p>
      
                </div>
                <div class="div1" style="margin-left: 50px">
                  <p class="fz12" style="margin-top:10px;">下单订单数</p>
                  <p class="fz22 fw" style="margin-top:10px;">19,359,329<span class="fz12">人</span></p>
                </div>

              </div>
              <div class="b3-r"></div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 下方表单区域 h68 w138 -->
    <el-table
      class="my-table"
      :data="tableData"
      style="width: 98%;margin-top:20px;"
      height="550"
      border
      :header-cell-style="{background:'#eeeeee'}"
    >
      <el-table-column prop="t1" label="图文ID" width="139"> </el-table-column>
      <el-table-column prop="t2" label="图文名称" width="156">
      </el-table-column>
      <el-table-column prop="t3" label="日期" width="148"> </el-table-column>
      <el-table-column prop="t4" label="图文日期" width="133">
      </el-table-column>
      <el-table-column prop="t5" label="阅读人数" width="122">
      </el-table-column>
      <el-table-column prop="t6" label="图文打开率" width="114">
      </el-table-column>
      <el-table-column prop="t7" label="图文引流PV" width="117">
      </el-table-column>
      <el-table-column prop="t8" label="图文引流PV" width="128">
      </el-table-column>
      <el-table-column prop="t9" label="下单人" width="120"> </el-table-column>
      <el-table-column prop="t10" label="图文打开率" width="120">
      </el-table-column>
      <el-table-column prop="t11" label="图文打开率" width="120">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options1: [{ name: "积木云公众号" }],
      //模拟数据
      tableData: [
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客公众号看板图文分析功能上线啦…",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客公众号看板图文分析功能上线啦…",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客公众号看板图文分析功能上线啦…",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
        {
          t1: "2018.03.05",
          t2: "积木云客，让经营更有数",
          t3: "2018.03.05",
          t4: "2018.03.05",
          t5: "100",
          t6: "100%",
          t7: "100",
          t8: "100",
          t9: "100",
          t10: "100",
          t11: "100",
        },
      ],
    };
  },
};
</script>
<style lang="less">
.OfficialAccounts {
  padding: 20px;
  padding-top: 40px;
  .title {
    display: flex;
    align-items: center;
    img {
      width: 20px;
    }
    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }
  // <!-- 顶部卡片区域 -->
  .top-card {
    margin-top: 30px;
    width: 98%;
    height: 435px;
    .main {
      display: flex;
      //小窗区域
      .h5 {
        width: 263px;
        height: 404px;
        .title {
          font-size: 12px;
          font-weight: 500;
          color: #333333;
        }
        .banner {
          margin-top: 8px;
          width: 221px;
          height: 97px;
          position: relative;

          img {
            width: 100%;
          }
          p {
            font-size: 10px;
            font-weight: 500;
            color: #ffffff;
            position: absolute;
            bottom: 7px;
            left: 10px;
            text-shadow: 0px 2px 7px rgba(14, 14, 14, 0.5);
          }
        }
        .body {
          margin-top: 10px;
          .cell {
            display: flex;
            margin-top: 15px;
            .text {
              height: 44px;
              font-size: 10px;
              font-weight: 400;
              color: #333333;
              line-height: 14px;
              border-bottom: 1px solid #f3f3f3;
              margin-right: 5px;
            }
            img {
              // margin-left: 5px;
              height: 44px;
            }
            &:nth-child(4) {
              margin-bottom: 20px;
            }
          }
          .first {
            margin-top: 0px;
          }
        }
      }
      //右侧数据展示区域
      .data {
        flex: 1;
        margin-left: 70px;
        .top {
          .fl {
            float: left;
            font-size: 16px;
            display: flex;
            align-items: flex-end;
            b {
              margin-left: 6px;
            }
            img {
              width: 24px;
            }
            .text {
              margin-left: 12px;
              color: #333;
              font-size: 12px;
              line-height: 24px;
            }
          }
          .fr {
            float: right;
            color: #999999;
            font-size: 12px;
            p {
              img {
                width: 16px;
                vertical-align: middle;
                //   margin-right: 10px;
              }
            }
            .my-select {
              margin-left: 25px;
            }
            .el-input .el-input__inner {
              margin-left: -15px;
              width: 120px;
            }
          }
        }
        .bottom {
          width: 100%;
          height: 330px;
          .text2 {
            position: absolute;
            top: 0;
            left: 160px;
            height: 90px;
            // background-color: transparent;
            display: flex;
            justify-content: center;
            z-index: 1;
            .div1 {
             display: flex;
             flex-direction:column;
             justify-content: flex-start;
             >p{
               margin-top: 5px;
             }
            }
          }
          .b1 {
            margin-top: 20px;
            width: 100%;
            height: 33%;
            // background-color: green;
            position: relative;
            display: flex;
            overflow: hidden;
            .b1-l {
              border-top: 90px solid;
              border-top-color: #7898ff;
              border-left: 10px solid transparent;
              border-right: 10px solid #ebecfc;
              height: 0;
              width: 160px;
              border-radius: 0;

              .text {
                position: absolute;
                top: 32px;
                left: 49px;
                display: flex;
                flex-direction: column;
                align-items: center;
              }
            }
            .b1-r {
             height: 90px;
              flex: 1;
              background-color: #ebecfc;
            }
          }
          .b2 {
            margin-top: -15px;
            width: 100%;
            height: 33%;
            position: relative;
            display: flex;
            overflow: hidden;
            .b2-l {
              margin-left: 10px;
              border-top: 90px solid;
              // border-top-color: linear-gradient(180deg, #7898FF 0%, #5E83F8 100%);
              border-top-color: #61e6df;
              border-left: 10px solid transparent;
              border-right: 10px solid #f2f2f2;
              height: 0;
              width: 140px;
              border-radius: 0;
              .text {
                position: absolute;
                top: 32px;
                left: 49px;
                display: flex;
                flex-direction: column;
                align-items: center;
              }
            }
            .b2-r {
              height: 90px;
              flex: 1;
              background-color: #f2f2f2;
             
            }
          }
          .b3 {
           margin-top: -15px;
            width: 100%;
            height: 33%;
            position: relative;
            display: flex;
            overflow: hidden;
            .b3-l {
              margin-left: 20px;
              border-top: 90px solid;
              // border-top-color: linear-gradient(180deg, #7898FF 0%, #5E83F8 100%);
              border-top-color: #ff925f;
              border-left: 10px solid transparent;
              border-right: 10px solid #faf0ed;
              height: 0;
              width: 120px;
              .text {
                position: absolute;
                top: 32px;
                left: 49px;
                display: flex;
                flex-direction: column;
                align-items: center;
              }
            }
            .b3-r {
              height: 90px;
              flex: 1;
              background-color: #faf0ed;
              
              
            }
          }
        }
      }
    }
  }
  //表格区域

  .my-table {
    //单独设置表头高度
 .el-table__header tr,
        .el-table__header th .cell{
          font-weight: 500 !important;
          padding: 0 !important;
        }
    [el-table_2_column_12]{
      background-color: #333 !important;
    }
    .cell{
      text-align: center !important;
      font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #333333;
padding:0  30px;
      // font-size: 22px;
    }
    .el-table__row{
      height: 85px;
    }
  }

  //公共样式区
  .fff {
    color: rgba(255, 255, 255, 0.87);
  }
  .fz26 {
    font-size: 26px;
  }
  .fz22{
    font-size: 22px;
  }
  .fz16 {
    font-size: 16px;
  }
  .fz12 {
    font-size: 12px;
  }
  .fw {
    font-weight: 600;
    white-space: nowrap;
  }
}
</style>